export default {
  //IP白名单设置
  systemWhiteSetting: {
    //columns searchColumns
    ip: 'IP',
    remake: '备注',
    status: '状态',
    createTime: '创建时间',
    platformName: '所属平台',
    operate: '操作',
    //placeholder
    placeholderIp: '请输入IP地址',
    placeholderRemake: '请输入备注',
    placeholderStatus: '请选择状态',
    placeholderCorrectIp: '输入的IP格式有误！',
    alertTitle: 'IP通配规则',
    alertDescription: '例如：192.168.8.1，192.168.8.*，192.168.8.0/24；*表示0-255，0/24表示0-24',
  },
  //日志管理
  systemLogs: {
    operatorUserName: '操作人员',
    operatorObjectName: '操作对象',
    operatorTypeMsg: '操作类型',
    operatorCode: '日志标志',
    operatorTime: '操作时间',
    operatorIp: '登录IP',
    operatorContent: '操作内容',
    url: '请求URL',
    operatorAfter: '操作提交的数据',
    operatorPre: '操作提交前的旧数据',
    operate: '操作',
  },
  //系统参数管理
  systemParams: {
    validateParametersTitle: '验证码参数配置',
    expiresParametersTitle: '过期时间参数配置',
    rebateParametersTitle: '返点参数配置',
    rebate_tmsv_dif: '返点最大差值',
    rebate_max_value: '返点最大值',
    backstage_login: '管理后台登录入口验证码',
    google_backstage_login: '管理后台登录入口Google验证码',
    ip_whitelist_flag: 'IP白名单登录验证',
    backstage_user_online_expire_time: '后台管理员在线过期时间',
    minute: '分钟',
    dataName: '数据名称',
    retentionTime: '留存时间/分钟',
    remark: '备注',
  },
  //菜单管理
  systemNavManage: {
    parentId: '上级菜单',
    name: '菜单名称',
    nameZh: '菜单名称（中文）',
    nameEn: '菜单名称（英语）',
    nameVie: '菜单名称（越南语）',
    category: '菜单类型',
    path: '路由地址',
    source: '菜单图标',
    code: '菜单编号',
    sort: '菜单排序',
    remark: '菜单备注',
    operate: '操作',

    placeholderParentId: '请选择上级菜单',
    placeholderCategory: '请选择菜单类型',
    placeholderName: '请输入菜单名称',
    placeholderNameZh: '请输入中文菜单名称',
    placeholderNameEn: '请输入英语菜单名称',
    placeholderNameVie: '请输入越南语菜单名称',
    placeholderPath: '请输入路由地址',
    placeholderSource: '请选择菜单图标',
    placeholderCode: '请输入菜单编号',
    placeholderSort: '请输入菜单排序',
    placeholderRemark: '请输入菜单备注',

    radioMenu: '菜单',
    radioButton: '按钮',
  },
  //游戏更新设置
  systemAppUpdateManage: {
    platformName: '所属平台',
    platformCode: '平台代码',
    name: '游戏名称',
    code: '游戏代码',
    currentVersion: '当前版本',
    updateUserName: '操作人',
    updateTime: '操作时间',
    updateVersion: '更新至版本',
    operate: '操作',

    tipsText1: '1.更新版本资源，请务必先上传资源附件；',
    tipsText2: '2.更新版本填写信息与上一版本一致时，则视为不更新；',
    tipsText3: '将文件拖到此处，或',
    tipsText4: '点击上传',
    tipsText5: '只能上传zip文件，且不超过500MB',
    tipsText6: '资源存放地址请勿随意更改!!',
    uploadTitle: '上传资源附件',
    gameHotterVersionTime: '更新时间',
    resourceStore: '资源存放地址',

    names: '游戏',
    amount: '数量',
    placeholderVersion: '请输入版本号',
    placeholderUpdateVersion: '请输入更新至版本',
    placeholderResourceStore: '请输入资源存放地址',
    placeholderCorrectResourceStore: '请输入正确的资源存放地址',
    commonMessage1: '只能上传zip文件！',
    commonMessage2: '文件大小不超过500MB！',
    commonMessage3: '只支持上传一个文件！',
    commonMessage4: '版本号格式不正确！',
    commonMessage5: '版本号不能为空！',
  },
  systemServerUpdateManage: {
    name: '游戏名称',
    code: '游戏代码',
    updateUserName: '操作人',
    updateTime: '操作时间',
    peopleNum: '正在游戏人数',
    status: "状态",
    operate: '操作',

  },
  //内测账号
  systemUserManagePrivateAccount: {
    account: '用户账号',
    balance: '账号余额',
    password: '登录密码',
    operate: '操作',

    placeholderAccount: '请输入用户账号',
    placeholderPassword: '请输入登录密码',
    placeholderBalance: '请输入账号余额',
  },
  //后台用户列表
  systemUserManage: {
    account: '用户账号',
    name: '用户昵称',
    realName: '用户姓名',
    avatar: '用户头像',
    roleName: '所属角色',
    managePlatformName: '授权平台',
    secretKey: '谷歌密钥',
    password: '登录密码',
    password2: '确认密码',
    verifyState: '验证状态',
    verifyState1: '开启',
    verifyState2: '关闭',
    lockFlag: '状态',
    lockFlag2: '正常',
    lockFlag3: '锁定',
    operate: '操作',

    placeholderAccount: '请输入用户账号',
    placeholderPassword: '请输入登录密码',
    placeholderName: '请输入用户昵称',
    placeholderRealName: '请输入用户姓名',
    placeholderRoleName: '请选择所属角色',
    placeholderManagePlatformName: '请选择授权平台',
    placeholderPlatformName: '请选择所属平台',
  },
  //角色管理
  systemRoleManage: {
    code: '角色编码',
    name: '角色名称',
    sort: '排序',
    operate: '操作',

    permission: '所拥有的权限',
    placeholderCode: '请输入角色编码',
    placeholderName: '请输入角色名称',
    placeholderSort: '请输入菜单排序',
    placeholderMenu: '请选择要授权的菜单',
  },
  //平台管理
  systemPlatformManage: {
    code: '平台代码',
    name: '平台名称',
    contact: '联系人',
    mobileNumber: '联系电话',
    domain: '绑定域名',
    customerServiceUrl: '客服地址',
    pumpingRatio: '盈亏抽成比例',
    gamePumpingRatio: '游戏抽成比例',
    sort: '排序',
    secretKey: 'AES秘钥',
    md5Key: 'MD5秘钥',
    type: '平台控盘类型',
    type1: '控盘',
    type2: '非控盘',
    account: '用户账号',
    password: '登录密码',
    password2: '确认密码',
    googleSecurityCode: '谷歌验证码',
    operate: '操作',

    game: '所拥有的游戏',
    verify: '校验',
    messageBox: '系统默认平台不可删除',
    placeholderCode: '请输入平台代码',
    placeholderCode2: '平台代码已存在',
    placeholderName: '请输入平台名称',
    placeholderSecretKey: '请输入AES秘钥',
    placeholderMd5Key: '请输入MD5秘钥',
    placeholderContact: '请输入联系人',
    placeholderMobileNumber: '请输入联系电话',
    placeholderDomain: '请输入绑定域名',
    placeholderCustomerServiceUrl: '请输入客服地址',
    placeholderPumpingRatio: '请输入抽成比例',
    placeholderGamePumpingRatio: '请输入游戏抽成比例',
    placeholderSort: '请输入排序',
    placeholderAccount: '请输入用户账号',
    placeholderPassword: '请输入登录密码',
    placeholderGame: '请选择要配置的游戏',
    walletType: "钱包类型",
    singleWallet: "单钱包",
    transferWallet: "转账钱包"
  },
  //敏感词管理
  systemSensitiveWord: {
    word: '敏感词',
    operate: '操作',

    placeholderSensitiveWord: '批量添加请用","隔开',
  },
  commonTitle: '暂无所属平台',
  // 对象存储
  systemResourceOss: {
    ossCode: "资源编号",
    endpoint: "资源地址",
    bucketName: "空间名",
    status: "状态",
    option: "操作",
    remark: "备注"
  },
  //第三方同步信息
  systemThirdPartySyncInfo: {
    platformCode: '所属平台',
    id: 'ID',
    transferId: '传输ID',
    requestUrl: 'RequestUrl',
    type: '类型',
    status: '状态',
    retryCount: '重试次数',
    beginTime: '开始时间',
    endTime: '结束时间',
    lastReqTime: '最后请求时间',
    lastRespTime: '最后返回时间',
    nextReqTime: '下次请求时间',
    jsonStr: '请求信息',
    errStr: '返回信息',
    datetime: '时间',
    operate: '操作',
    succeed: '成功',
    fail: '失败',
    all: '全部',
    userAccount: '用户账号',
    expenses: '投注',
    income: '派奖',
    refund: '退还',
    frozen: '冻结金额',
    thaw: '解冻金额',
    cancel: '撤单',
    settle: '结算',
    sum: '对账',
    adjust: '活动奖励',
    auditStatus: '审核状态',
    auditRemark: '审核备注',
    tabsMongodb: '实时数据',
    tabsEs: '归档数据',
    tabsRetryData: '重试数据',
    radioAuditStatus1: '未审核',
    radioAuditStatus2: '已审核',
    remark1: '注：超过3分钟的成功记录',
    remark2: '注：只保留最新72小时记录及异常记录',
    message1: '第三方该笔记录存在！',
    message2: '第三方该笔记录不存在！',
    message3: '状态为失败时才可批量操作！',
    message4: '重试成功！',
    message5: '重试失败！',
    message6: '撤单成功！',
    message7: '撤单失败！',
    searchRemark: '（输入null表示搜索用户账号为空）',
    oId: 'Oid',
    orderMsg: 'OrderMsg',
    retryStatus1: '待重试',
    retryStatus2: '重试成功',
    retryType1: '解冻',
    retryType2: '批量SQL失败',
    retryType3: '批量请求三方失败',
    diffTime: "时间间隔 (大于等于的秒数)",
    errStrSearch: "返回信息（输入null表示搜索返回信息为空）",
    orderDetail: "订单详情",
    revokeAmount: "撤单金额",
  },
  //第三方账变核查
  systemThirdPartyAmountVerification: {
    platformCode: '所属平台',
    id: 'ID',
    transferId: '第三方订单ID/transferId', //传输ID
    requestUrl: 'RequestUrl',
    type: '类型',
    status: '状态',
    retryCount: '重试次数',
    beginTime: '开始时间',
    endTime: '结束时间',
    lastReqTime: '最后请求时间',
    lastRespTime: '最后返回时间',
    nextReqTime: '下次请求时间',
    jsonStr: '请求信息',
    errStr: '返回信息',
    datetime: '时间',
    operate: '操作',
    succeed: '成功',
    fail: '失败',
    all: '全部',
    userAccount: '用户账号',
    expenses: '投注',
    income: '派奖',
    refund: '退还',
    frozen: '冻结金额',
    thaw: '解冻金额',
    cancel: '撤单',
    settle: '结算',
    sum: '对账',
    auditStatus: '审核状态',
    auditRemark: '审核备注',
    tabsBtn1: '有账变有订单',
    tabsBtn2: '有账变无订单',
    tabsBtn3: '无账变有订单',
    tabsBtn4: '无账变无订单',
    tabsBtn9: '冻结解冻异常订单',
    tabsBtn5: '账变详情',
    tabsBtn6: '订单详情',
    tabsBtn7: '审核',
    tabsBtn8: '补偿',
    radioAuditStatus1: '未审核',
    radioAuditStatus2: '已审核',
    compensateAmount: '补偿金额',
    orderId: 'orderId',
    eventId: 'eventId',
    compensateRemark: '补偿备注',
    oId: '订单号',
    gameId: '游戏',
    batAuditBtn: '批量审核',

    placeholderAuditStatus: '请选择审核状态',
    placeholderAuditRemark: '请输入审核备注',
    placeholderCompensateAmount: '请输入补偿金额',
    placeholderCompensateRemark: '请输入补偿备注',
    placeholderEventId: '请输入eventId',
    placeholderOId: '请输入24位字母或数字组合的订单号',
    placeholderFrozen: '请输入frozen',
    placeholderPrize: '请输入prize',
    placeholderTime: '请选择时间',
  },
  //第三方对账
  systemThirdPartyReconciliation: {
    date: '时间',
    platformCode: '所属平台',
    account: '账号',
    betCount: '投注次数(三方/账变)',
    betCount2: '投注笔数(T订单/J订单/三方)',
    betAmount: '投注金额(三方账变/账变/T订单/J订单/三方订单)',
    awardSettle: '派奖金额(三方账变/账变/T订单/J订单/三方订单)',
    returnCount: '退款次数(三方/账变/T订单/J订单)',
    returnAmount: '退款金额(三方/账变/T订单/J订单)',
    awardCount: '活动奖励次数(三方/账变)',
    awardAmount: '活动奖励金额(三方/账变)',
    freezeCount: '冻结次数(三方/账变)',
    freezeAmount: '冻结金额(三方/账变)',
    unfreezeCount: '解冻次数(三方/账变)',
    unfreezeAmount: '解冻金额(三方/账变)',
    dataExceptionStatus: '数据状态',
    auditStatus: '审核状态',
    auditRemark: '审核备注',
    handleAmount: '处理金额',
    auditUserName: '审核人',
    auditTime: '审核时间',
    operate: '操作',

    all: '全部',
    amountDetail: '账变详情',
    orderDetail: '订单详情',
    radioAuditStatus1: '未审核',
    radioAuditStatus2: '已审核',
    normal: '正常',
    abnormal: '异常',
    uncalibrated: '未校准',
    auditBtn: '审核',
    batAuditBtn: '批量审核',
    dataCheck: '数据核对',
    refresh: '刷新第三方数据',
    placeholderAuditStatus: '请选择审核状态',
    placeholderAuditRemark: '请输入审核备注',

    compensationAmount: "补偿金额",
    deductionAmount: "扣除金额",
    examine: '异常检查',
    examineResult: '找不到以下结果',
  },
  systemDictManage: {
    code: '字典编码',
    dictValue: '字典名称(CN)',
    dictVieValue: '字典名称(VN)',
    dictEnValue: '字典名称(EN)',
    parentName: '上级字典',
    dictKey: '字典键值',
    sort: '排序',
    isSealed: '封存',
    remark: '字典备注',
    operate: '操作',

    isSealedYes: '是',
    isSealedNo: '否',
    placeholderCode: '请输入字典编码',
    placeholderDictValue: '请输入字典名称(CN)',
    placeholderDictVieValue: '请输入字典名称(VN)',
    placeholderDictEnValue: '请输入字典名称(EN)',
    placeholderSort: '请输入字典排序',
    placeholderRemark: '请输入审核备注',
    placeholderDictKey: '请输入字典键值',
  },

}
